import { Button } from 'components/Button';
import { StackedRadioCardGroup } from 'components/Forms';
import { Heading } from 'components/Typography';
import { ScheduleContextV3, withScheduleMachineStateV3 } from 'domains/signupv3/schedule/context';
import { isUndefined, noop } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const EnterAppointmentType: React.FC = () => {
  const { send } = ScheduleContextV3.useActorRef();

  const { t } = useTranslation();
  const [value, setValue] = useState<'confirmConsultation' | 'confirmTherapySession' | undefined>(undefined);

  const options = [
    {
      label: t('signup.direct.steps.enteringAppointmentType.therapySession.title'),
      description: t('signup.direct.steps.enteringAppointmentType.therapySession.description'),
      value: 'confirmTherapySession',
    },
    {
      label: t('signup.direct.steps.enteringAppointmentType.consultation.title'),
      description: t('signup.direct.steps.enteringAppointmentType.consultation.description'),
      value: 'confirmConsultation',
    },
  ];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value as 'confirmTherapySession' | 'confirmConsultation');
  };

  const handleSubmit = () => {
    if (!value) return;
    send({ type: value });
  };

  return (
    <>
      <Heading level="h2" className="mb-16">
        {t(`signup.direct.steps.enteringAppointmentType.title`)}
      </Heading>

      <Heading level="h7" className="mb-64 sm-d:mb-40">
        {t(`signup.direct.steps.enteringAppointmentType.subtitle`)}
      </Heading>

      <StackedRadioCardGroup
        label={t('signup.direct.steps.enteringAppointmentType.selectOne')}
        className="gap-14"
        disabled={false}
        showSelectedDot
        options={options}
        onChange={handleChange}
        name="select-target"
        clearValue={noop}
        setError={noop}
        setValue={noop}
        tFunc={t}
        autoFocus
      />
      <Button
        data-testid="appointment-type-submit-button"
        size="lg"
        className="mt-64 sm-d:mt-40 sm-d:w-full"
        onClick={handleSubmit}
        disabled={isUndefined(value)}
      >
        {t(`signup.direct.steps.enterUseInsurance.submit.continue`)}
      </Button>
    </>
  );
};

export const ScheduleV3EnterAppointmentType = withScheduleMachineStateV3(EnterAppointmentType, 'enterAppointmentType');
